import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const ROCKET_IMG = 'https://cdn.magicpatterns.com/uploads/1sDuRe7GydwnvuJraRp2FM/Screenshot_2026-02-11_at_3.31.07_PM.png';
export function RocketLaunch() {
  const [phase, setPhase] = useState<'pad' | 'launching' | 'gone'>('pad');
  useEffect(() => {
    const launchTimer = setTimeout(() => setPhase('launching'), 3000);
    const goneTimer = setTimeout(() => setPhase('gone'), 13000);
    return () => {
      clearTimeout(launchTimer);
      clearTimeout(goneTimer);
    };
  }, []);
  if (phase === 'gone') return null;
  return <div className="fixed inset-0 pointer-events-none z-30 overflow-hidden" data-id="element-354">
      <AnimatePresence data-id="element-355">
        {phase === 'pad' && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0,
        transition: {
          duration: 0.5
        }
      }} className="absolute bottom-0 right-8 md:right-16 flex flex-col items-center" data-id="element-356">
            <div className="w-20 h-3 rounded-full bg-purple-500/30 blur-md mb-1" data-id="element-357" />
            <div className="w-24 h-2 rounded-full bg-gradient-to-r from-transparent via-purple-500/40 to-transparent" data-id="element-358" />
          </motion.div>}
      </AnimatePresence>

      <motion.div className="absolute right-8 md:right-16 flex flex-col items-center" initial={{
      bottom: 8
    }} animate={phase === 'launching' ? {
      bottom: '120vh',
      transition: {
        duration: 9,
        ease: [0.2, 0.8, 0.3, 1]
      }
    } : {
      bottom: 8
    }} data-id="element-359">
        <motion.div animate={phase === 'pad' ? {
        x: [0, -1.5, 1.5, -1, 1, 0],
        transition: {
          duration: 0.5,
          repeat: Infinity,
          repeatDelay: 0.3
        }
      } : {
        x: 0
      }} data-id="element-360">
          <img src={ROCKET_IMG} alt="Rocket" className="w-14 h-14 md:w-20 md:h-20 object-contain drop-shadow-[0_0_15px_rgba(251,191,36,0.6)]" style={{
          transform: 'rotate(-45deg)'
        }} data-id="element-361" />
        </motion.div>

        <AnimatePresence data-id="element-362">
          {phase === 'launching' && <motion.div initial={{
          opacity: 0,
          scaleY: 0
        }} animate={{
          opacity: 1,
          scaleY: 1,
          transition: {
            duration: 0.4
          }
        }} className="flex flex-col items-center -mt-2" data-id="element-363">
              <div className="w-4 h-16 md:w-5 md:h-24 bg-gradient-to-b from-yellow-400 via-orange-500 to-transparent rounded-full blur-[2px] animate-pulse" data-id="element-364" />
              <div className="w-6 h-24 md:w-8 md:h-36 bg-gradient-to-b from-orange-400/40 via-red-500/20 to-transparent rounded-full blur-md" data-id="element-365" />
              {[0, 1, 2].map(i => <motion.div key={i} className="absolute w-1.5 h-1.5 rounded-full bg-yellow-300" initial={{
            opacity: 1,
            y: 20
          }} animate={{
            opacity: [1, 0],
            y: [20, 80 + i * 20],
            x: [(i % 2 === 0 ? -1 : 1) * 8, (i % 2 === 0 ? 1 : -1) * 12]
          }} transition={{
            duration: 1.2,
            repeat: Infinity,
            delay: i * 0.3,
            ease: 'easeOut'
          }} data-id="element-366" />)}
            </motion.div>}
        </AnimatePresence>

        <AnimatePresence data-id="element-367">
          {phase === 'pad' && <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} className="flex items-center justify-center -mt-1" data-id="element-368">
              {[0, 1].map(i => <motion.div key={i} className="absolute w-2 h-2 rounded-full bg-gray-400/30" animate={{
            opacity: [0.3, 0.6, 0],
            y: [0, -20 - i * 10],
            x: [(i % 2 === 0 ? -1 : 1) * 5, (i % 2 === 0 ? 1 : -1) * 10],
            scale: [0.5, 1.5, 2]
          }} transition={{
            duration: 2,
            repeat: Infinity,
            delay: i * 0.7,
            ease: 'easeOut'
          }} data-id="element-369" />)}
            </motion.div>}
        </AnimatePresence>
      </motion.div>
    </div>;
}